/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { gql } from '@apollo/client';
import { object, shape, string } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import InternationalFlowerDeliveryBlock from './InternationalFlowerDeliveryBlock';
import { GRAPHQL_ENV } from '../../../gql';
import * as app from '../../../../state/ducks/App';
import Data from './ViewData';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const brandSelectors = app.ducks.brand.selectors;
const InternationalFlowerDeliveryPage = ({ brand, page }) => {
    const International_Flower_Delivery_PAGE_QUERY = gql`
            query InternationalFlowerDeliveryQuery {
                findContentPage(brand: "${brand['domain-name']}", url: "${page.path}", contentType: "${page.contentType}", environment: "${GRAPHQL_ENV}", locale: "en-us") {
                    content
                }
            }
        `;

    return (
        <Query query={International_Flower_Delivery_PAGE_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null; // skeleton component
                }

                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: International_Flower_Delivery_PAGE_QUERY,
                        component: 'GraphqlInternationalDelivery.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: International_Flower_Delivery_PAGE_QUERY,
                        component: 'GraphqlInternationalDelivery.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                return (
                    <>
                        <GraphqlSeoHeadTags seoData={Data.seo} />
                        <InternationalFlowerDeliveryBlock data={Data} />
                    </>

                );
            }}
        </Query>
    );
};

InternationalFlowerDeliveryPage.propTypes = {
    brand: object.isRequired,
    page: shape({
        contentType: string.isRequired,
        path: string.isRequired,
    }).isRequired,
};
const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
});

export default withRouter(connect(mapStateToProps)(InternationalFlowerDeliveryPage));
